import React from 'react';

const TeamMemberCard = ({ name, role, photo, useDarkBlock = false }) => {
  return (
    <div className="w-full flex flex-col h-full">
      {/* Foto del miembro - Responsiva con aspect-ratio */}
      <div className="relative w-full aspect-square sm:aspect-video md:aspect-square rounded-md overflow-hidden bg-gray-200">
        <img src={photo} alt={name} className="w-full h-full object-cover" />
      </div>

      {/* Bloque de información con altura fija para consistencia */}
      {useDarkBlock ? (
        <div className="bg-primary-dark text-white rounded-md mt-3 p-4 flex-1 flex flex-col">
          <h3 className="font-serif text-xl mb-2 whitespace-nowrap truncate">{name}</h3>
          <p className="font-sans text-sm opacity-90">{role}</p>
        </div>
      ) : (
        <div className="bg-white border border-gray-200 rounded-md mt-3 p-4 flex-1 flex flex-col min-h-[100px]">
          <h3 className="font-serif text-xl text-text-main mb-2 whitespace-nowrap truncate">{name}</h3>
          <p className="font-sans text-sm text-gray-600">{role}</p>
        </div>
      )}
    </div>
  );
};

export default TeamMemberCard;